import { Skeleton } from "components/Map/Skeleton";
import { Map } from "components/Map/Map";
import { useState } from "react";
import { isAccomodation, isTour } from "lib/predicates";
import { sanitizeHtml } from "lib/util";

export const MapSection = ({
  item,
  section,
  activateOnClick = false,
}: {
  item: Travelguide.OOI;
  section: Travelguide.POISection.Map;
  activateOnClick?: boolean;
}) => {
  const [showMap, setShowMap] = useState(false);

  return (
    <section className="flex flex-col gap-5">
      {!isTour(item) && <h2 className="px-4 md:px-6">Lage</h2>}
      {activateOnClick && !showMap ? (
        <Skeleton onChange={() => setShowMap(true)} />
      ) : (
        <Map item={item} elpro={section.elpro} />
      )}
      {isAccomodation(item) && section.locationText && (
        <p className="px-4 md:px-6 md:text-center">
          {sanitizeHtml(section.locationText, [])}
        </p>
      )}
    </section>
  );
};
